import React from 'react';
import BlurToggle from 'components/BlurToggle';
import { useBackgroundBlur, useIsInteractionDisabled } from '../state';

export default function EditSceneBlurToggle() {
  const { isBackgroundBlurEnabled, handleBlurChange } = useBackgroundBlur();
  const { isInteractionDisabled } = useIsInteractionDisabled();

  return (
    <BlurToggle
      label="Background Blur"
      isActive={isBackgroundBlurEnabled}
      isDisabled={isInteractionDisabled}
      onChange={handleBlurChange}
    />
  );
}
